module.exports = __webpack_public_path__ + "img/ttsMarket2.9887256c.png";